import axios from 'axios';
import * as api from './../api/mainIndex';
import { clearError, setError } from './error.js';
import { apiEndpoint } from '../constants/links.js';
import { AD_REDIRECT, USR_REDIRECT } from '../constants/path.js';
import { AUTH,START_LOADING,END_LOADING, FORGOT_PASSWORD, RESET_PASSWORD, CLEAR,ACTION, RESET, USER, FETCH, EXAM, RESULT } from '../constants/actionTypes';

export const signIn = (formData, navigate) => async (dispatch) => {
  try {
    dispatch({type:START_LOADING,payload:{type:AUTH}})
    const { data } = await api.signIn(formData);
    dispatch({ type: AUTH, payload:{data, type:AUTH}});
    dispatch({ type: FETCH, payload:{data:data.data, type:USER}});

    if(data?.status === 99){
      navigate(AD_REDIRECT);
    }
    else if(data?.status === 14){
      navigate(USR_REDIRECT);
    }

    dispatch({type:END_LOADING,payload:{type:AUTH}})
    dispatch({type:END_LOADING,payload:{type:USER}})
    dispatch(clearError())

    return data;

  } catch (err) {
  const message =
    err?.message === "Network Error"
      ? "Network error. Please check your connection."
      : err?.response?.data?.message || "Unexpected error occurred";

  const statusCode = err?.response?.data?.statusCode || err?.response?.status || 500;

  dispatch(setError({ message, statusCode }));
  dispatch({ type: END_LOADING, payload: { type: AUTH } });
  return { error: true, message, statusCode };
}

};

export const signUp = (formData, handleNext, enqueueSnackbar) => async (dispatch) => {
  try {
    dispatch({type:START_LOADING,payload:{type:AUTH}})
    const { data } = await api.signUp(formData);
    dispatch({ type: AUTH, payload:{data, type:AUTH}});
    dispatch(clearError())
    dispatch({type:END_LOADING,payload:{type:AUTH}})
    if(data.message){
      enqueueSnackbar( data?.message, {
        variant: 'success',
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    handleNext()

  } catch (err) {
  const message =
    err?.message === "Network Error"
      ? "Network error. Please check your connection."
      : err?.response?.data?.message || "Unexpected error occurred";

  const statusCode = err?.response?.data?.statusCode || err?.response?.status || 500;

  dispatch(setError({ message, statusCode }));
  dispatch({ type: END_LOADING, payload: { type: AUTH } });
}
};

export const signUpWithScreenshot = (formData, handleNext, enqueueSnackbar) => async (dispatch) => {
  dispatch({type:START_LOADING,payload:{type:AUTH}})
  try {
    const res = await axios.post(`${apiEndpoint}/auth/signUp`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    if(res.message){
      enqueueSnackbar( res?.message, {
        variant: 'success',
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    handleNext();
    dispatch({type:END_LOADING,payload:{type:AUTH}})

  } catch (err) {
    if(err?.message === "Network Error")
      {dispatch(setError("Something went wrong!"))
      dispatch({type:END_LOADING,payload:{type:AUTH}})
    }
    else{
      dispatch(setError(err?.response?.data?.message))
      dispatch({type:END_LOADING,payload:{type:AUTH}})
    }
    
  }
};

export const logout = (navigate) => async (dispatch) => {
  try {
    dispatch({type:START_LOADING,payload:{type:AUTH}});
    const { data } = await api.logout();
    dispatch({ type: AUTH,payload:{data,type:AUTH} });
    dispatch({ type: RESET,payload:{data,type:USER} });
    dispatch({ type: RESET,payload:{data,type:RESULT} });
    dispatch({ type: 'CLEAR_STATE',payload:{data,type:EXAM} });
    navigate('/auth/login');
    localStorage.clear();
    sessionStorage.clear();
    dispatch({type:END_LOADING,payload:{type:AUTH}})
  } catch (error) {
    dispatch(setError(error?.response?.data?.message))
    dispatch({type:END_LOADING,payload:{type:AUTH}})
  }
};

export const forgotPassword =(email) =>async(dispatch)=>{
  try {
      dispatch({type:START_LOADING,payload:{type:AUTH}})
      const {data} = await api.forgotPassword(email);
      dispatch({type:FORGOT_PASSWORD,payload:{data, type:AUTH}});
      dispatch({type:END_LOADING,payload:{type:AUTH}})

  } catch (error) {
      // dispatch(setError(error?.response?.data?.message))
      // dispatch({type:END_LOADING,payload:{type:AUTH}})
  const message =
      error?.message === "Network Error"
      ? "Network error. Please check your connection."
      : error?.response?.data?.message || "Unexpected error occurred";

  const statusCode = error?.response?.data?.statusCode || error?.response?.status || 500; 
  dispatch(setError({ message, statusCode }));
  dispatch({ type: END_LOADING, payload: { type: AUTH } });
  return { error: true, message, statusCode };
  }
}

export const sendMail =(formData,enqueueSnackbar) =>async(dispatch)=>{
  try {
      dispatch({type:START_LOADING,payload:{type:AUTH}})
      const {data} = await api.sendMail(formData);
      dispatch({type:ACTION,payload:{data, type:AUTH}});
      if(data?.message){
        enqueueSnackbar( data?.message, {
          variant: 'success',
          anchorOrigin: { vertical: 'top', horizontal: 'left' },
        });
      }
      dispatch({type:END_LOADING,payload:{type:AUTH}})

  } catch (error) {
      dispatch(setError(error?.response?.data?.message));
      if(error?.response?.data?.message){
        enqueueSnackbar( error?.response?.data?.message, {
          variant: 'error',
          anchorOrigin: { vertical: 'top', horizontal: 'left' },
        });
      }
      dispatch({type:END_LOADING,payload:{type:AUTH}})
  }
}

export const resetPassword =(password,resetToken, navigate ,enqueueSnackbar) =>async(dispatch)=>{
  try {
      dispatch({type:START_LOADING,payload:{type:AUTH}})
      const {data} = await api.resetPassword(password, resetToken);
      dispatch({type:RESET_PASSWORD,payload:{data, type:AUTH}});
      if(data?.message){
        enqueueSnackbar( data?.message, {
          variant: 'success',
          anchorOrigin: { vertical: 'top', horizontal: 'left' },
        });
      }
      navigate('/auth/login')
      dispatch({type:END_LOADING,payload:{type:AUTH}})

  } catch (error) {
      // dispatch(setError(error?.response?.data?.message))
      // dispatch({type:END_LOADING,payload:{type:AUTH}})

      const message =
          error?.message === "Network Error"
          ? "Network error. Please check your connection."
          : error?.response?.data?.message || "Unexpected error occurred";

      const statusCode = error?.response?.data?.statusCode || error?.response?.status || 500; 
      dispatch(setError({ message, statusCode }));
      dispatch({ type: END_LOADING, payload: { type: AUTH } });
      return { error: true, message, statusCode };
  }
}

export const verifyEmail =(password,resetToken) =>async(dispatch)=>{
  try {
      dispatch({type:START_LOADING,payload:{type:AUTH}})
      const {data} = await api.resetPassword(password, resetToken);
      dispatch({type:RESET_PASSWORD,payload:{data, type:AUTH}});
      dispatch({type:END_LOADING,payload:{type:AUTH}})

  } catch (error) {
      dispatch(setError(error?.response?.data?.message))
      dispatch({type:END_LOADING,payload:{type:AUTH}})
  }
}

export const sendOtp = ({userForm, handleNext, enqueueSnackbar}) => async (dispatch) => {
  dispatch({type:START_LOADING,payload:{type:AUTH}})
  try {
    const { data } = await api.sendOtp(userForm);
    dispatch({ type: "SEND_OTP", payload:{data, type:AUTH}});
    dispatch(clearError())
    if(data?.message){
      enqueueSnackbar( data?.message, {
        variant: 'success',
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    handleNext()
    dispatch({type:END_LOADING,payload:{type:AUTH}})

  } catch (error) {
    if(error?.message === "Network Error")
    {dispatch(setError("Something went wrong!"))
    dispatch({type:END_LOADING,payload:{type:AUTH}})
  }
  else{
    dispatch(setError(error?.response?.data?.message))
    dispatch({type:END_LOADING,payload:{type:AUTH}})
  }

  }
};

// export const clear = () => async (dispatch) => {
//   try {
//     dispatch({ type: CLEAR,payload:{type:AUTH} });

//   } catch (error) {
//     dispatch(setError(error?.response?.data?.message))
//   }
// };

export const clear = () => async (dispatch) => {
  try {
    dispatch({ type: CLEAR, payload: { type: AUTH } });
  } catch (error) {
    const message =
      error?.message === "Network Error"
        ? "Network error. Please check your connection."
        : error?.response?.data?.message || "Something went wrong while clearing data.";

    const statusCode = error?.response?.data?.statusCode || error?.response?.status || 500;

    dispatch(setError({ message, statusCode }));
  }
};